import api from "./api";

export const BuscarPedidoPorCodigo = async (codigo) => {
  try {
    const pd = await api.get(`/buscar/pedidos/${codigo}`);
    return pd.data;
  } catch (error) {
    throw error;
  }
};

export const BuscarEstabelecimentoPorNome = async (busca) => {
  try {
    const estabelecimento = await api.get(`/buscar/estabelecimentos/${busca}`);
    return estabelecimento.data;
  } catch (error) {
    throw error;
  }
};

export const BuscarUsuarioPorNome = async (busca) => {
  try {
    const usuario = await api.get(`/buscar/usuarios/${busca}`);
    return usuario.data;
  } catch (error) {
    throw error;
  }
};

export const BuscarTipoEstabelecimentoPorNome = async (busca) => {
  try {
    const tipo = await api.get(`/buscar/tipos-estabelecimentos/${busca}`);
    return tipo.data;
  } catch (error) {
    throw error;
  }
};

export const BuscarEntregadorPorNomeOuCpf = async (busca) => {
  try {
    const entregadores = await api.get(`/buscar/entregadores/${busca}`);
    return entregadores.data;
  } catch (error) {
    throw error;
  }
};
